// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__j22_f","title":"Info_title__K-mzM","selects":"Info_selects__3Gd-9","requiredAsterisk":"Info_requiredAsterisk__1EuuQ"};